type AssetOptions = {
    accept?: string;
    w: number;
    h: number;
    language: string;
};

export const forWeb = (assetUrl: string, options: AssetOptions) => {
    return rebuild(assetUrl, options.language)
        + withIntent('web')
        + withAccept(options.accept)
        + withSize(options.w, options.h);
};

export const forPrint = (assetUrl: string, options: AssetOptions) => {
    return rebuild(assetUrl, options.language)
        + withIntent('print')
        + withAccept(options.accept)
        + withSize(options.w, options.h);
};

export const addIntentTo = (url: string, intent: 'web' | 'print') => {
    return `${url}?intent=${intent}`;
};

const rebuild = (assetUrl: string, language: string) => {
    const { origin, pathname } = new URL(assetUrl);
    return `${origin}${pathname}/${language}?`;
};

const withIntent = (intent: 'web' | 'print') => {
    return `&intent=${intent}`;
};

const withSize = (width: number, height: number) => {
    return `&w=${width}&h=${height}`;
};

const withAccept = (accept?: string) => {
    return accept === undefined ? '' : `&accept=${encodeURIComponent(accept)}`;
};